
import { supabase } from "@/integrations/supabase/client";
import { logger } from "@/lib/logger";
import { AuthEmailResponse, handleEmailServiceError } from "./types";

/**
 * Service for account verification emails
 */
export const verificationService = {
  /**
   * Send verification email for new accounts
   * Uses Supabase's built-in email verification
   */
  async sendVerificationEmail(email: string, fullName: string): Promise<AuthEmailResponse> {
    try {
      // Request Supabase to send a verification email
      const { error } = await supabase.auth.resend({
        type: 'signup',
        email
      });
      
      if (error) {
        // Check if this is a rate limit error
        if (
          error.message?.toLowerCase().includes('rate limit') || 
          error.status === 429
        ) {
          return { 
            success: false, 
            error: "For security reasons, we limit how often emails can be sent. Please wait a few minutes before trying again.",
            rateLimited: true 
          };
        }
        
        throw error;
      }
      
      logger.info({
        message: "Verification email sent successfully via Supabase",
        context: { email }
      });
      
      return { success: true };
    } catch (error) {
      return handleEmailServiceError(error, { operation: "send verification email", email });
    }
  }
};
